import useSWR from 'swr';

import fetchForecastedWind from 'common/api/wind';
import { useMemo } from 'react';
import type { Units } from '../../../types/units';

const TEN_MINUTES_IN_MS = 60 * 10000;

type FetchParams = {
  spotId: string;
  days: number;
  intervalHours: number;
  corrected: boolean;
  units: Units;
};

const useFetchForecastedWind = (spotId: string, units: Units, skip?: boolean) => {
  const days = 1;
  const intervalHours = 1;
  const corrected = false;

  const args = useMemo<FetchParams | undefined>(
    () => (!skip ? { spotId, days, intervalHours, corrected, units } : undefined),
    [corrected, skip, spotId, units],
  );

  const fetcher = ({
    spotId: spotIdArg,
    days: daysArg,
    intervalHours: intervalHoursArg,
    corrected: correctedArg,
    units: unitsArg,
  }: FetchParams) =>
    fetchForecastedWind(spotIdArg, daysArg, intervalHoursArg, correctedArg, unitsArg);

  const {
    data,
    error,
    isLoading: loading,
  } = useSWR(args, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    errorRetryCount: 0,
    // Forecast data doesn't change often, no need to refresh every time they toggle between the graph types
    dedupingInterval: TEN_MINUTES_IN_MS,
  });

  return { data, error, loading };
};

export default useFetchForecastedWind;
